import { IAssetCategoryTypeResponse } from '@kcftech/prometheustypescriptapiclient';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
    DataSourceSort,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';

export const assetCategoryTypeDefaultSort: DataSourceSort[] = [
    { field: 'Name', dir: 'asc' },
];

export type AssetCategoryTypesFilter = Readonly<{
    nameSearch?: string;
}>;

export type UseAssetCategoryTypeDataSourceOptions = BaseDataSourceOptions<
    IAssetCategoryTypeResponse,
    AssetCategoryTypesFilter
>;

const getAssetCategoryTypes: DataSourceQuery<
    IAssetCategoryTypeResponse,
    AssetCategoryTypesFilter
> = async ({ filter: { nameSearch }, sort, page, pageLimit }) => {
    const filter = nameSearch ? Filter.contains('Name', nameSearch) : undefined;
    const orderBy = buildOrderBy(sort);

    return toDataSourceResult(
        sdClient.getAssetClassificationTypes({ filter, page, pageLimit, orderBy })
    );
};

export type AssetCategoryTypePagedDataSource = PagedDataSource<
    IAssetCategoryTypeResponse,
    AssetCategoryTypesFilter
>;

export function usePagedAssetCategoryTypeDataSource({
    defaultSort = assetCategoryTypeDefaultSort,
    ...options
}: UseAssetCategoryTypeDataSourceOptions): AssetCategoryTypePagedDataSource {
    return usePagedDataSource({
        defaultSort,
        ...options,
        query: getAssetCategoryTypes,
    });
}

export type AssetCategoryTypeInfiniteDataSource = InfiniteDataSource<
    IAssetCategoryTypeResponse,
    AssetCategoryTypesFilter
>;

export function useInfiniteAssetCategoryTypeDataSource({
    defaultSort = assetCategoryTypeDefaultSort,
    ...options
}: UseAssetCategoryTypeDataSourceOptions): AssetCategoryTypeInfiniteDataSource {
    return useInfiniteDataSource({
        defaultSort,
        ...options,
        query: getAssetCategoryTypes,
    });
}
